import { Trans, useTranslation } from 'react-i18next';

import { Body1, Stack, Text } from '@myphx-engineering/phx-design-system';
import { constants } from '@myphx-engineering/phx-design-system/framework';

import type { PricingInfo } from '../../../util/config/get-pricing';
import MedicationPricing from '../order-details/MedicationPricing';

export const SwitchToInsuranceDetails = ({
    pricingInfo,
}: {
    pricingInfo: PricingInfo;
}) => {
    const { t } = useTranslation();

    return (
        <Stack gap="md">
            <Body1>
                <Trans
                    i18nKey="switchPage.toInsuranceDescription.line1"
                    components={{
                        1: <Text component="span" fw={700} />,
                    }}
                />
            </Body1>

            <MedicationPricing pricingInfo={pricingInfo} />

            <Body1>{t('switchPage.toInsuranceDescription.line2')}</Body1>
            <Body1>
                {t('switchPage.toInsuranceDescription.line3', {
                    reg: constants.unicode.REGISTERED,
                })}
            </Body1>
        </Stack>
    );
};
